export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://api.dev.soargi.com',
  /** URL base do storage (ex.: Azure Blob) para imagens de organização quando a API retorna path relativo. Opcional. */
  storageBaseUrl: undefined as string | undefined,
  firebase: {
    apiKey: '***************************************',
    authDomain: '************************',
    projectId: '***********************************',
    storageBucket: '************************',
    messagingSenderId: '*********************',
    appId: '*******************************************',
    measurementId: '*********************',
  },
};
